
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M235.2 44.5c-15 2.7-32.7 10-45.7 18.8-7.8 5.3-21.4 18.5-27.6 26.7-6.1 8.1-13.8 23-17.3 33.5-7.5 22.6-7.5 50.5 0 73 5.4 16.3 14 30.8 25.1 42.6 3.6 3.8 6.4 7.1 6.2 7.3s-4.6 2.5-9.8 5.1c-28 14.4-50.5 37.3-65 66.1-15 30-19.7 66-12 91.1 9.2 29.6 34.3 52.6 64.1 58.7 6.7 1.4 19.9 1.6 102.8 1.6s96.1-.2 102.8-1.6c29.8-6.1 54.9-29.1 64.1-58.7 6-19.5 4.4-46.6-4.1-72.1-12.2-36.4-39-67.7-72.9-85.1-5.2-2.6-9.6-4.9-9.8-5.1s2.5-3.4 6-7.2c14.9-15.7 25.2-36.4 29.4-59.1 1.9-10.5 1.9-29.3 0-40.2-2.9-16.9-11.4-36.7-21.4-49.9-6.2-8.2-19.8-21.4-27.6-26.7-13.4-9-30.8-16.1-46.3-18.8-10.3-1.8-31-1.8-41 0M274 87.7c42.6 10.4 66.9 55.6 52.2 97.2-4.1 11.4-8.6 18.5-17.7 27.6s-16.1 13.5-27.8 17.8c-7.1 2.6-9.9 3.1-21.5 3.5-15 .5-22.9-.9-33.9-5.8-37.4-16.9-54.1-61.3-37.2-98.8 12.4-27.5 41.6-45.4 71.4-43.6 4.4.2 10.9 1.2 14.5 2.1m14.3 190.4c44.3 4.6 81 36.3 92.4 79.7 2 7.8 2.6 12.2 2.6 22.7.1 11.4-.1 13.7-2.2 18.8-4.4 11.1-14.3 20.6-25.8 25-5.8 2.2-6 2.2-95.3 2.5-61 .2-91.5-.1-95.8-.8-9-1.5-16.8-5.6-23.3-12-10-9.9-13.5-20.2-12.6-36.5 3.1-50.9 43.5-93.7 93.8-99.3 10.8-1.3 54.8-1.3 66.2-.1"}})])
          )
        }
      }
    